export default Object.freeze({
    BidConfigurationDetails: 1,
    BidScheduling: 2,
    PayCodeSelection: 3,
    EmployeeSelection: 4,
    AbsenceThreshold: 5,
    CalendarRules: 6,
    BidConditions: 7,
});
